/**
 * @package		Al hirafiyin web app
 * @desc		Page script 
 *
 * @copyright	Copyright (C) 2022 Jaayfer abderrahim, Inc. All rights reserved.
 * @license	 see LICENSE.txt
 */
import '../css/craftsman-profile.css';
import craftsmanTools from '../../commons/js/craftsman-tools';
import photosBrowser from '../../commons/js/photos-browser';
import app from '../../app';
import $ from 'jquery';
// on resize window
$(window).on('resize', event => {
  let maxTitleHeight = 0;
  let maxDescHeight = 0;
  $('.crafts-list li .data-wrapper .title').css('height', '');
  $('.crafts-list li .data-wrapper .desc').css('height', '');
  const $firstDataRow = $('.crafts-list li').first();
  const titlePositions = [];
  let eqTitlePositions = false;
  $firstDataRow.find('.data-wrapper .title').each((idx, el) => {
    titlePositions.push($(el).position().top);
    if (idx) {
      eqTitlePositions = titlePositions[idx] === titlePositions[idx - 1];
    }
  });
  if (eqTitlePositions) {
    $('.crafts-list li .data-wrapper .title').each((idx, el) => maxTitleHeight = maxTitleHeight < $(el).height() ? $(el).height() : maxTitleHeight);
    $('.crafts-list li .data-wrapper .title').css('height', maxTitleHeight);
    $('.crafts-list li .data-wrapper .desc').each((idx, el) => maxDescHeight = maxDescHeight < $(el).height() ? $(el).height() : maxDescHeight);
    $('.crafts-list li .data-wrapper .desc').css('height', maxDescHeight);
  }
}).trigger('resize');

// open photos galory
if ($('body').hasClass('iframe')) {
  const photosId = app.utilities.hashString(window.location.href);
  const images = [];
  $('.init-photo-browser a').each(function (idx) {
    images.push({
      src: $(this).attr('href'),
      width: $(this).attr('data-pswp-width'),
      height: $(this).attr('data-pswp-height'),
      alt: $(this).attr('alt') || undefined
    });
    $(this).on('click', function () {
      window.parent.postMessage({
        type: 'open-photos-browser',
        photos: {
          id: photosId,
          photo: idx
        }
      }, '*');
    });
  });
  window.parent.postMessage({
    type: 'get-photos-browser',
    photos: {
      id: photosId,
      source: images
    },
    options: {
      referralLink: location.pathname
    }
  }, '*');
} else {
  photosBrowser.initialize('.init-photo-browser');
}

// like profile
$('.craftsman-profile-page .btn-like-craftsman').on('click', function () {
  const userId = location.pathname.match(/\/\d+(?=\/|$)/)[0].substring(1);
  craftsmanTools.likeProfile(userId);
});

// get more actions
$('.craftsman-profile-page .btn-more-actions').on('click', function () {
  const userId = location.pathname.match(/\/\d+(?=\/|$)/)[0].substring(1);
  craftsmanTools.getAdditionalActionsSheet(userId, window.location.href);
});

// open social media links
$('.social-network').each((idx, el) => {
  const $el = $(el);
  const link = $el.data('link') || '';
  if (!$el.hasClass('enabled') || !String(link).length) {
    return;
  }
  $el.css('cursor', 'pointer').on('click', ev => craftsmanTools.openSocialMediaLink(link));
});